import { useMutation } from "urql";

import { CreateCreditUnderwritingDocument } from "../../../graphql/generated.ts";

export function useCreateCreditUnderwriting() {
  return useMutation(CreateCreditUnderwritingDocument);
}
